import React from "react";
import cl from "./Footer.module.css";
import { NavLink } from "react-router-dom";

const Footer = (props) => {
  return (
    <footer className={cl.app_footer}>
      <div className={cl.app_footer_main}>
        <div className={cl.app_footer_links}>
          <h1>COMPANY</h1>
          <NavLink className={cl.footer_link} to="">
            Home
          </NavLink>
          <NavLink className={cl.footer_link} to="/about">
            About
          </NavLink>
         
          <NavLink className={cl.footer_link} to="/products">
            Products
          </NavLink>
          <NavLink className={cl.footer_link} to="/contacts">
            Contacts
          </NavLink>
        </div>
        <div className={cl.app_footer_links}>
          <h1>ASSISTANCE</h1>
          <NavLink className={cl.footer_link} to="/policy">
            Privacy policy
          </NavLink>
          <NavLink className={cl.footer_link} to="/terms">
            Terms of service
          </NavLink>
          <NavLink className={cl.footer_link} to="/refund-policy">
            Refund Policy
          </NavLink>
          <NavLink className={cl.footer_link} to="/shipping-policy">
            Shipping Policy
          </NavLink>
          <NavLink className={cl.footer_link} to="/cookies-policy ">
            Cookies Policy
          </NavLink>
        </div>      
      </div>
      <div className={cl.app_footer_bottom_line}>
        <p>Copyright 2024 {props.shopName}</p>
        <div className={cl.app_footer_info}>
          <h2>WE ACCEPT</h2>
          <img
            src="https://cdn.icon-icons.com/icons2/1186/PNG/512/1490135017-visa_82256.png"
            alt="Visa"
          />
          <img
            src="https://www.iconarchive.com/download/i76278/designbolts/credit-card-payment/Master-Card.ico"
            alt="Master Card"
          />
        </div>
      </div>
    </footer>
  );
};

export default Footer;
